import { RefundActionTypes } from '../Constants/Types';
import { RefundState } from '../Interfaces/refund-interface';

const initialState: RefundState = {
  refunds: [],
  refund: null,
  lrefunds: false,
  lrefund: false,
  pages: 0,
  total: 0
};

const RefundsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case RefundActionTypes.LOADING_REFUNDS:
      return { ...state, lrefunds: true };
    case RefundActionTypes.LOADING_REFUND:
      return { ...state, lrefund: true };
    case RefundActionTypes.GET_REFUNDS:
      return {
        ...state,
        refunds: action.payload.data,
        pages: action.payload.pages,
        total: action.payload.total,
        lrefunds: false
      };
    case RefundActionTypes.GET_REFUND:
      return { ...state, refund: action.payload, lrefund: false };
    case RefundActionTypes.CREATE_REFUND:
      return { ...state, refund: action.payload, lrefund: false };
    case RefundActionTypes.UPDATE_REFUND:
      return { ...state, refund: action.payload, lrefund: false };
    case RefundActionTypes.REMOVE_REFUND:
      return { ...state, refund: action.payload, lrefund: false };
    case RefundActionTypes.ERROR_REFUNDS:
      return { ...state, lrefunds: false };
    case RefundActionTypes.ERROR_REFUND:
      return { ...state, lrefund: false };
    default:
      return state;
  }
};

export default RefundsReducer; 